import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { rem } from 'polished';
import {
  FlexRow,
  FlexColCenter,
  FlexRowCenter,
  FlexCol,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TextP } from '../../Defaults/Text';

enum TagType {
  NEW = 'NEW',
  SALE = 'SALE',
  SECOND_HAND = 'SECOND_HAND',
  FREE_DELIVERY = 'FREE_DELIVERY',
  GIFT = 'GIFT',
  DEAL = 'DEAL'
}

interface Props {
  text: string;
  type: string;
  theme?: any;
  title?: string;
}

function Tag({ text, type, theme, title }: Props) {
  const loadColorBasedOnItemType = () => {
    switch (type) {
      case TagType.NEW: {
        return theme.colors.white;
      }
      case TagType.SALE: {
        return theme.colors.white;
      }
      case TagType.FREE_DELIVERY: {
        return 'white';
      }
      case TagType.GIFT: {
        return 'white';
      }
      default: {
        return theme.colors.black;
      }
    }
  };

  const loadBgColorBasedOnItemType = () => {
    switch (type) {
      case TagType.NEW: {
        return theme.tagColors.new;
      }
      case TagType.SALE: {
        return theme.tagColors.sale;
      }
      case TagType.FREE_DELIVERY: {
        return theme.colors.successColor;
      }
      case TagType.GIFT: {
        return theme.colors.successColor;
      }
      default: {
        return 'transparent';
      }
    }
  };

  const loadBorderColorBasedOnItemType = () => {
    switch (type) {
      case TagType.FREE_DELIVERY: {
        return 'white';
      }
      default: {
        return 'transparent';
      }
    }
  };

  const color = loadColorBasedOnItemType();
  const bgColor = loadBgColorBasedOnItemType();
  const isSale = type === 'SALE';
  const isGift = type === 'GIFT';

  // if (type === TagType.FREE_DELIVERY) {
  //   return (
  //     <SquareWrapper color={color} bgColor={bgColor}>
  //       {text}
  //     </SquareWrapper>
  //   );
  // }

  return (
    <Wrapper
      title={title}
      color={color}
      bgColor={bgColor}
      isSale={isSale}
      isGift={isGift}
    >
      {text}
    </Wrapper>
  );
}

const Wrapper = styled.div<{
  color: string;
  bgColor: string;
  isSale: boolean;
  isGift?: boolean;
}>`
  width: auto;
  flex-shrink: 0;
  /* padding: ${rem(18)} ${rem(8)}; */
  box-shadow: 0 -1px 15px 0px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: ${({ color }) => color};
  font-weight: 400;
  font-size: ${({ isSale }) => (isSale ? '22px' : '16px')};
  font-family: ${({ theme }) => theme.font.primary};
  text-transform: uppercase;
  margin-right: ${rem(8)};
  line-height: ${rem(20)};
  border-radius: 0.25rem;
  height: auto;
  background: white;
`;

const SquareWrapper = styled.div<{
  color: string;
  bgColor: string;
}>`
  height: ${rem(32)};
  padding: ${rem(4)} ${rem(8)};
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: ${({ color }) => color};
  background-color: ${({ bgColor }) => bgColor};
  border-radius: ${rem(4)};
  font-weight: 400;
  font-size: ${rem(12)};
  font-family: ${({ theme }) => theme.font.primary};
  text-transform: uppercase;
  margin-right: ${rem(8)};
  line-height: ${rem(20)};
  border: ${rem(1)} solid ${({ theme }) => theme.colors.stockCountAvailable};
  white-space: nowrap;
  letter-spacing: ${rem(1.1)};
`;

const withThemeTag: any = withTheme(Tag);
export { withThemeTag as DsiTag, TagType };
